var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaboratorniDobavyaneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "21.3,2.7 21.3,0 18.7,0 18.7,2.7 16,2.7 16,5.3 18.7,5.3 18.7,8 21.3,8 21.3,5.3 24,5.3 24,2.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.7,9.3c0-0.6,0-6.7,0-6.7H5.3c0,0,0,5.8,0,6.7c-2.2,1-5.3,2.7-5.3,8C0,20.4,3.2,24,8,24c4.1,0,8-3.9,8-8 C16,12.7,13.6,10.3,10.7,9.3z M14.7,17.3c-3.2,1.8-5.1-1.7-7.8-1.8c-2.2-0.1-3.6,1.1-5.6,1.8c0-3.6,2.7-5.8,5.3-6.7 c0-0.7,0-6.7,0-6.7h2.7c0,0,0,6.2,0,6.7C12,11.6,15,12.8,14.7,17.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 0,
    className: "st0",
    width: 8,
    height: 1.3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaboratorniDobavyaneIcon);
export default __webpack_public_path__ + "static/media/laboratorni_dobavyane_icon.3456abbe.svg";
export { ForwardRef as ReactComponent };